// config/footerLinks.js
export const footerLinks = {
  company: [
    { label: 'Corporate Presentation', href: '/corporate-presentation.pdf' },
    { label: 'Executive Brief', href: '/executive-brief.pdf' },
    { label: 'About Us', href: '/about-us' },
    { label: 'Sectors', href: '/sectors' },
    { label: 'Why Choose Us', href: '/why-choose-us' },
    { label: 'Contact Us', href: '/contact-us' }
  ],
  solutions: [
    { label: 'Intelligence & Data Technologies', href: '/solutions/intelligence-data-technologies' },
    { label: 'Cyber Defense & Threat Management', href: '/solutions/cyber-defense-and-threat-management' },
    { label: 'Drones & Airspace Security', href: '/solutions/drones-and-airspace-security' },
    { label: 'Secure Data & Critical Systems', href: '/solutions/secure-data-and-critical-systems' },
    { label: 'Urban & Public-Space Security', href: '/solutions/urban-and-public-space-security' },
    { label: 'Extended Capabilities', href: '/solutions/extended-capabilities' },
  ]
};